import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const useNetwork = () => {
  const [isSlowNetwork, setIsSlowNetwork] = useState<boolean>(false);
  const slowNetworkThreshold: number = 1.5; // Network threshold value here (e.g., 1.5 Mbps)

  const pathname = useLocation();
  useEffect(() => {
    const connection =
      (navigator as any).connection ||
      (navigator as any).mozConnection ||
      (navigator as any).webkitConnection;
    if (connection && connection.downlink <= slowNetworkThreshold) {
      setIsSlowNetwork(true);
    } else {
      setIsSlowNetwork(false);
    }
  }, [pathname]);
  return isSlowNetwork;
};

export default useNetwork;
